import { BaseDto } from '../base.dto';
import { BillingProductDto } from '../billing-product';
import { BillingSubscriptionDto } from '../billing-subscription';

export class BillingSubscriptionMerchantDto extends BaseDto {
  billingSubscriptionId: number;
  billingProductId: number;
  merchantId: number;
  isActive: boolean;
  billingSubscriptionFrequencyId: number;
  billingSubscription?: BillingSubscriptionDto;
  billingProduct?: BillingProductDto;
}
